module.exports = __webpack_public_path__ + "img/清洁交通伙伴关系.ed5225c5.png";